import { render, staticRenderFns } from "./wiseGuide.vue?vue&type=template&id=63880e69&scoped=true"
import script from "./wiseGuide.vue?vue&type=script&lang=js"
export * from "./wiseGuide.vue?vue&type=script&lang=js"
import style0 from "./wiseGuide.vue?vue&type=style&index=0&id=63880e69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63880e69",
  null
  
)

export default component.exports